import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PackagesWishListCard from "src/Components/WebsiteComponents/HomePage/Cards/PackagesWishListCard";
import TestWhishListCard from "src/Components/WebsiteComponents/HomePage/Cards/TestWhishListCard";
import httpRequest from "src/helpers/httpRequest";
import { IPaginated } from "src/types/paginated";
import qs from "qs";
import { Loader } from "lucide-react";
import NoItemUI from "src/Components/NoItemUI";
import { useNavigate } from "react-router-dom";
import NoItemImg from "src/assets/images/not-data/no-package.png";
import InfinteScrollWrapper from "src/Components/GlobalComponents/Widget/InfinteScrollWrapper";

const tests = [
  {
    id: 1,
    name: "Life Platinum Package",
    description: "Blood Test",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz1wmn4xyHnFvtA5PyxXD3AR8dYo5ap4DZ3A&s",
    tests: ["Blood Test", "Liver Function Test", "Thyroid Function Test"],
    regularPrice: 1000,
    salePrice: 800,
  },
  {
    id: 2,
    name: "Life Platinum Package",
    description: "Blood Test",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz1wmn4xyHnFvtA5PyxXD3AR8dYo5ap4DZ3A&s",
    tests: ["Blood Test", "Liver Function Test", "Thyroid Function Test"],
    regularPrice: 1000,
    salePrice: 800,
  },
  {
    id: 3,
    name: "Life Platinum Package",
    description: "Blood Test",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz1wmn4xyHnFvtA5PyxXD3AR8dYo5ap4DZ3A&s",
    tests: ["Blood Test", "Liver Function Test", "Thyroid Function Test"],
    regularPrice: 1000,
    salePrice: 800,
  },
];

interface IObj {
  _id: string;
  name: string;
  description: string;
  image: string;
  regularPrice: number;
  salePrice: number;
  isLiked: boolean;
  prescriptionRequired: boolean;
  noOfTests: number;
  nameOftests: string[];
}
interface IResponse {
  documents: IObj[];
  paginated: IPaginated;
}

const PackagesWhishList = ({ onClose }: { onClose: () => void }) => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [data, setData] = useState<IObj[]>([]);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });
  const [queryParams, setQueryParams] = useState<{
    page: number;
    limit: number;
    bool: boolean;
  }>({
    page: 1,
    limit: 10,
    bool: false,
  });
  const handleRemove = (obj: { productId: string }) => {
    if (data?.length > 1) {
      setData((prev) => prev?.filter((v) => v._id !== obj?.productId));
    } else {
      handleQueryParamsChange({
        page: queryParams?.page > 1 ? queryParams?.page - 1 : queryParams?.page,
      });
    }
  };

  const fetch = async (params: Partial<typeof queryParams>) => {
    setIsLoader(true);
    const { bool, ...actulaParams } = params;
    const { res, err } = await httpRequest<IResponse>({
      path: `/diagnostic-package/fav?${qs.stringify(actulaParams)}`,
    });
    if (res) {
      const { documents = [], paginated = { currentPage: 1, totalPages: 1 } } =
        res;
      setData((prev) => [...prev, ...documents]);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const handleQueryParamsChange = (
    params: Partial<typeof queryParams>,
    reset = true
  ) => {
    let updatedParams = { ...queryParams, ...params };
    if (reset) {
      setPaginated({
        currentPage: 1,
        totalPages: 1,
      });
      updatedParams.page = 1;
      setData([]);
    }
    fetch(updatedParams);
    setQueryParams(updatedParams);
  };

  useEffect(() => {
    handleQueryParamsChange(queryParams);
  }, []);

  return (
    <>
      <InfinteScrollWrapper
        isLoading={isLoader}
        length={data?.length}
        currentPage={queryParams?.page}
        totalPages={paginated?.totalPages}
        onLoadMore={(page) => {
          handleQueryParamsChange({ page: page }, false);
        }}
        calculateHeight
        noDataOptions={{
          text: "No Packages Found",
          text2: "Your packages wishlist is empty. Explore and save packages for quick access.",
          iconImagePath: NoItemImg,
          buttonOnPress: () => {
            onClose();
            navigate("/health-packages");
          },
          buttonText: "Discover Packages",
        }}
      >
        {data.map((test, index) => (
          <PackagesWishListCard
            key={test._id}
            data={test}
            heart_id={`heart-${index}`}
            button_id={`button-${index}`}
            handleRemove={() => handleRemove({ productId: test._id })}
          />
        ))}
      </InfinteScrollWrapper>
    </>
  );
};

export default PackagesWhishList;
